import { Card, Drawer } from "antd";
import React, { } from "react";
import {
  AccessLevel,
  RowLevelAction,
  StepDetailProps,
  section,
} from "../../types/types";
import ViewSingleBlueprintForm from "./viewSingleBlueprintForm";
import CustomSteps from "../../components/steps/customSteps";
import RecordHeader from "../../components/recordHeader/recordHeader";

interface Props {
  urlparams: Map<string, string>;
  open: boolean;
  platformAction: RowLevelAction;
  setOpen: (value: boolean) => void;
  blueprintApi: string;
  title: string;
  isCreateFlow?: boolean;
  isRelatedInfo?: boolean;
  isNewRelatedInfo?: boolean;
  userAccessLevel: AccessLevel;
  recordIds?: any[];
  loanNos?: any[];
  customerNames?: any[];
  refreshTable: Function;
  allowEdits?: boolean;
  selectedRows?: any[];
  // prefillColumns?: string[];
  moduleCode: string;
  renderCustomDetailPage?: Function;
  steps?: StepDetailProps;
  allowedActionsForRenderingCustomDetailPage?: string[];
  extraActionsOnRecordCallback?: Function;
  header?: section;
  dataApi?: string;
}

const ViewRecord: React.FC<Props> = ({
  title,
  urlparams,
  open,
  setOpen,
  blueprintApi,
  isCreateFlow,
  isRelatedInfo,
  isNewRelatedInfo,
  userAccessLevel,
  platformAction,
  recordIds,
  loanNos,
  customerNames,
  refreshTable,
  allowEdits,
  selectedRows,
  // prefillColumns,
  moduleCode,
  renderCustomDetailPage,
  steps,
  allowedActionsForRenderingCustomDetailPage,
  extraActionsOnRecordCallback,
  header,
  dataApi
}) => {



  const renderSingleBlueprintForm = () => {

    return (
      (blueprintApi && blueprintApi.length > 0) ?
        <ViewSingleBlueprintForm
          isCreateFlow={isCreateFlow}
          isRelatedInfo={isRelatedInfo}
          isNewRelatedInfo={isNewRelatedInfo}
          open={open}
          renderCustomDetailPage={renderCustomDetailPage}
          urlparams={urlparams}
          setOpen={setOpen}
          userAccessLevel={userAccessLevel}
          platformAction={platformAction}
          blueprintApi={blueprintApi}
          recordIds={recordIds}
          loanNos={loanNos}
          customerNames={customerNames}
          refreshTable={refreshTable}
          allowEdits={allowEdits ?? true}
          selectedRows={selectedRows}
          // prefillColumns={prefillColumns}
          moduleCode={moduleCode}
          dataApi={dataApi}
          title={title}
          allowedActionsForRenderingCustomDetailPage={allowedActionsForRenderingCustomDetailPage}
          extraActionsOnRecordCallback={extraActionsOnRecordCallback}
        /> : <></>
    );
  }

  const renderStepFlow = () => {

    return (
      <>
        {
          (steps && steps.screens.length > 0) ? (<CustomSteps
            isCreateFlow={isCreateFlow}
            isRelatedInfo={isRelatedInfo}
            open={open}
            renderCustomDetailPage={renderCustomDetailPage}
            urlparams={urlparams}
            setOpen={setOpen}
            userAccessLevel={userAccessLevel}
            platformAction={platformAction}
            stepFlowProps={steps}
            recordIds={recordIds}
            loanNos={loanNos}
            customerNames={customerNames}
            refreshTable={refreshTable}
            allowEdits={allowEdits ?? true}
            selectedRows={selectedRows}
            // prefillColumns={prefillColumns}
            moduleCode={moduleCode} />
          )
            : <></>
        }
      </>
    );
  }

  return (
    <Drawer
      open={open}
      title={title}
      destroyOnClose={true}
      onClose={() => {
        setOpen(false);
      }}
      maskClosable={false}
      className="details-drawer"
    >
      {(header && !isCreateFlow) ? <RecordHeader urlparams={urlparams} section={header}></RecordHeader> : <></>}

      <Card>
        {renderStepFlow()}
        {renderSingleBlueprintForm()}
      </Card>
    </Drawer >
  );
};

export default React.memo(ViewRecord);
